<p-toolbar>
    <button class="btn btn-link" #clearSelection [disabled]="!selected?.length" (click)="selected = []; SelectItem.next([])">
        Clear Selection
    </button>
    <span>
        {{ selected?.length }}
        rows selected.
    </span>
    <div style="padding-left: 1vw" *featureFlag="'manageUsers-sendUserCredentials'">
        <button
            title="Creates a randomly generated password and sends email to user with login information and time entry instructions."
            pButton pRipple severity="primary" id="btnSendcredentials" icon="pi pi-envelope"
            label="Assign/Send Password" [disabled]="!dataTable?.selection?.length" [hidden]="userInfo?.LegacyPswdReset"
            (click)="onSendCredentials(dataTable.selection)"></button>
    </div>
    <div class="flex items-center">
        <p-checkbox id="cbinactive" binary="true" [(ngModel)]="showInactive"
            (ngModelChange)="onShowInactiveChange($event)" data-toggle="tooltip" data-placement="top"
            title="Include inactive users" #cbShowInactive></p-checkbox>
        <label class="ml-2">Show Inactive Users</label>
    </div>
    <div style="padding-left: 1vw">
        <button Title="Download" pButton pRipple severity="primary" id="download-csv" icon="pi pi-download"
            pTooltip="Download" (click)="dataTable.exportCSV()"></button>
    </div>
    <!-- <ef-column-search [elements]="elements"></ef-column-search> -->
    <p-message
        severity="info"
        text="Select user to activate action buttons."
    ></p-message>
</p-toolbar>
<!-- virtualscroll not working with frozen columns -->
<div [ngStyle]="{ 'height': this.height }" id="manage-users">
    <div>
        <p-table stripedRows #dataTable
            dataKey="id"
            [value]="items"
            [loading]="loading"
            [scrollable]="true"
            [scrollHeight]="this.height"
            editMode="row"
            [(selection)]="selected"
            selectionMode="Multiple"
            exportFilename="users"
            [rowTrackBy]="trackById"
            (selectionChange)="SelectItem.next($event)"
            (onFilter)="dataTableFilter($event)"
            [columns]="cols"
        >
            <ng-template pTemplate="emptymessage">
                <tr class="empty-table">
                    <td [attr.colspan]="numCols" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header" let-item let-columns>
                <tr class="column-header">
                    <!-- Edit -->
                    <th class="edit-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                        <!-- <i class="fa far fa-edit" style="font-size: 1.5em" title="Edit"></i> -->
                    </th>
                    <!-- Status-->
                    <th class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                        <!-- <i class="pi pi-question-circle" style="font-size: 1.65em" title="Status"></i> -->
                    </th>
                    <!-- Selection -->
                    <th class="select-cell" pFrozenColumn  [frozen]="IsColumnFrozen">
                        <p-tableHeaderCheckbox *ngIf="!editing"></p-tableHeaderCheckbox>
                    </th>
                    <!-- Person -->
                    <th pSortableColumn="EmployeeName" pFrozenColumn [frozen]="IsColumnFrozen">
                        Person
                        <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="EmployeeName" display="menu" class="ml-auto" />
                    </th>
                    <!-- Active -->
                    <th class=" edit-cell" style="width: 5em" *ngIf="cbShowInactive.checked">
                        Inactive
                    </th>
                    <!--  IDENTIFICATION GROUP -->
                    <!-- Type -->
                    <th pSortableColumn="IsConsultant">
                        Type
                        <p-sortIcon field="IsConsultant" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- account # -->
                    <th pSortableColumn="AccountNumber">
                        Account #
                        <p-sortIcon field="AccountNumber" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="AccountNumber" display="menu" class="ml-auto" />
                    </th>
                    <!-- user id -->
                    <th pSortableColumn="EUserID">
                        User ID
                        <p-sortIcon field="EUserID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="EUserID" display="menu" class="ml-auto" />
                    </th>
                    <!-- password -->
                    <th *ngIf="userInfo?.LegacyPswdReset">
                        Password
                    </th>
                    <!-- supervisor -->
                    <th pFrozenColumn [frozen]="IsSupervisorColumnFrozen" alignFrozen="left" pSortableColumn="SupervisorListID">
                        Supervisor
                        <p-sortIcon field="SupervisorListID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Mobile # -->
                    <th pSortableColumn="Mobilewithprovider" *ngIf="timeChecked">
                        Mobile #
                        <p-sortIcon field="Mobilewithprovider" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="Mobilewithprovider" display="menu" class="ml-auto" />
                    </th>
                    <!-- email -->
                    <th pSortableColumn="EmailAddr" *ngIf="timeChecked">
                        Email
                        <p-sortIcon field="EmailAddr" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="EmailAddr" display="menu" class="ml-auto" />
                    </th>
                    <!--  TIME GROUP -->
                    <!-- Week Start -->
                    <th pSortableColumn="FirstDayofWeekID" *ngIf="timeChecked">
                        Week Start
                        <p-sortIcon field="FirstDayofWeekID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Default SI -->
                    <th pSortableColumn="SIListID" *ngIf="timeChecked">
                        Default SI
                        <p-sortIcon field="SIListID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Default PI -->
                    <th pSortableColumn="PIListID" *ngIf="timeChecked">
                        Default PI
                        <p-sortIcon field="PIListID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Holiday Auths -->
                    <th pSortableColumn="AuthorizedHolidays" *ngIf="timeChecked">
                        Holiday Auths
                        <p-sortIcon field="AuthorizedHolidays" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Split Day -->
                    <th pSortableColumn="TimeCardSplitDayID" *ngIf="timeChecked">
                        Split Day
                        <p-sortIcon field="TimeCardSplitDayID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- EXPENSE GROUP -->
                    <!-- Expense Entry -->
                    <th pSortableColumn="ExpenseAllowed" *ngIf="expenseChecked">
                        Expense Entry
                        <p-sortIcon field="ExpenseAllowed" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Credit Card -->
                    <th pSortableColumn="CCAccountListID" *ngIf="expenseChecked">
                        Credit Card
                        <p-sortIcon field="CCAccountListID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- REMINDERS GROUP -->
                    <!-- Expected Hrs Per Day -->
                    <th pSortableColumn="Expectedhrsperday" *ngIf="timeChecked">
                        Expected Hrs Per Day
                        <p-sortIcon field="Expectedhrsperday" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Expected Hrs Per Week -->
                    <th pSortableColumn="Expectedhrsperweek" *ngIf="timeChecked">
                        Expected Hrs Per Week
                        <p-sortIcon field="Expectedhrsperweek" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Do Not Remind -->
                    <th pSortableColumn="IsPartTime" *ngIf="timeChecked">
                        Do Not Remind
                        <p-sortIcon field="IsPartTime" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Time Zone -->
                    <th pSortableColumn="EmpTimeZone" *ngIf="timeChecked">
                        Time Zone
                        <p-sortIcon field="EmpTimeZone" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Reminder Delivery -->
                    <th pSortableColumn="ReminderdeliveryID" *ngIf="timeChecked">
                        Reminder Delivery
                        <p-sortIcon field="ReminderdeliveryID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- PROCESSING GROUP -->
                    <!-- Cost Center -->
                    <th pSortableColumn="CostCenterID" *ngIf="processingChecked">
                        Cost Center
                        <p-sortIcon field="CostCenterID" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Unique Pay Cycle -->
                    <th pSortableColumn="PayrollFrequency" *ngIf="processingChecked">
                        Unique Pay Cycle
                        <p-sortIcon field="PayrollFrequency" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Usertype -->
                    <th pSortableColumn="Usertype" *ngIf="processingChecked">
                        Usertype
                        <p-sortIcon field="Usertype" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Hire Date -->
                    <th id="hiredate" pSortableColumn="HireDate" *ngIf="processingChecked">
                        Hire Date
                        <p-sortIcon field="HireDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Release Date -->
                    <th pSortableColumn="ReleaseDate" *ngIf="processingChecked">
                        Release Date
                        <p-sortIcon field="ReleaseDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <!-- Lock out -->
                    <th pSortableColumn="LockDate" *ngIf="timeChecked">
                        Lock out
                        <p-sortIcon field="LockDate" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-edit="editing" let-ri="rowIndex" let-rowData>
                <tr [ngClass]="{ inactive: !item.IsActive }" [pEditableRow]="item" data-id="row-{{ item.id }}">
                    <!--  STATUS GROUP -->
                    <!-- Edit -->
                    <td class="edit-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                        <button title="Edit" *ngIf="
                                !edit &&
                                (!editing?.id || editing?.id === item?.id) &&
                                selected?.length < 2
                            " pButton type="button" pInitEditableRow icon="pi pi-pencil"
                                class="p-button-rounded p-button-text" (click)="onRowEditInit(item)"></button>
                            <button title="Save" *ngIf="edit" pButton type="button" pSaveEditableRow icon="pi pi-check"
                                class="p-button-rounded p-button-text p-button-success"
                                (click)="onRowEditSave(item)" style="margin-right: 0.5rem;"></button>
                            <button title="Cancel" *ngIf="edit" pButton type="button" pCancelEditableRow
                                icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger"
                                (click)="onRowEditCancel(item)"></button>
                    </td>
                    <!-- Status-->
                    <td class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                        <div (click)="onStatusClick(item)" class="status-cell">
                            <ef-status-icon [status]="item?.Status?.StatusCode"
                                [message]="item?.Status?.Message"></ef-status-icon>
                        </div>
                    </td>
                    <!-- Selection -->
                    <td class="select-cell" pFrozenColumn  [frozen]="IsColumnFrozen">
                        <p-tableCheckbox [value]="item" *ngIf="!editing"></p-tableCheckbox>
                    </td>
                    <!-- Person -->
                    <td pFrozenColumn [frozen]="IsColumnFrozen">
                        {{ item.EmployeeName }}
                    </td>
                    <!-- Active -->
                    <td *ngIf="cbShowInactive.checked" class="edit-cell">
                        <i *ngIf="!item?.IsActive" style="font-size: 12px;" [ngClass]="{
                            pi: true,
                            'pi-times': !item?.IsActive
                        }"></i>
                    </td>
                    <!--  IDENTIFICATION GROUP -->
                    <!-- Type -->
                    <td>
                        {{ item?.IsConsultant ? 'Con' : 'Emp' }}
                    </td>
                    <!-- account # -->
                    <td>
                        {{ item?.AccountNumber }}
                    </td>
                    <!-- user id -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input title="Uesr Id" pInputText [(ngModel)]="item.EUserID" />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ item?.EUserID }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- password -->
                    <td *ngIf="userInfo?.LegacyPswdReset">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input title="Password" pPassword type="password" [(ngModel)]="item.EPassword" />
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span class="password">
                                    {{
                                    item?.EPassword && item?.EUserID
                                    ? '●'.repeat(12)
                                    : ''
                                    }}
                                </span>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- supervisor -->
                    <td pFrozenColumn [frozen]="IsSupervisorColumnFrozen" alignFrozen="left">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="supervisors" [rowData]="item"
                                        property="SupervisorListID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="supervisors"
                                    [filter]="true"
                                    [(ngModel)]="item.SupervisorListID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        supervisors
                                        | itemlookup
                                            : 'value'
                                            : item?.SupervisorListID
                                    )?.label
                                ">
                                    {{
                                    (
                                    supervisors
                                    | itemlookup
                                    : 'value'
                                    : item?.SupervisorListID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Mobile # -->
                    <td *ngIf="timeChecked">
                        {{ item?.Mobilewithprovider }}
                    </td>
                    <!-- email -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input title="Email Address" *ngIf="emailEnabled" id="tbEmailAddress" pInputText
                                    [(ngModel)]="item.EmailAddr" />
                                <span *ngIf="!emailEnabled">{{
                                    item?.EmailAddr
                                    }}</span>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ item?.EmailAddr }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!--  TIME GROUP -->
                    <!-- Week Start -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="daysOfWeek" [rowData]="item"
                                        property="FirstDayofWeekID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="daysOfWeek"
                                    [filter]="true"
                                    [(ngModel)]="item.FirstDayofWeekID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        daysOfWeek
                                        | itemlookup
                                            : 'value'
                                            : item?.FirstDayofWeekID
                                    )?.label
                                ">
                                    {{
                                    (
                                    daysOfWeek
                                    | itemlookup
                                    : 'value'
                                    : item?.FirstDayofWeekID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Default SI -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown id="ddlServiceItem" [items]="activeServiceItems" [rowData]="item"
                                        property="SIListID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="serviceItems"
                                    [filter]="true"
                                    [(ngModel)]="item.SIListID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        serviceItems
                                        | itemlookup: 'value':item?.SIListID
                                    )?.label
                                ">
                                    {{
                                    (
                                    serviceItems
                                    | itemlookup: 'value':item?.SIListID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Default PI -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="payrollSelectItems" [rowData]="item"
                                        property="PIListID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    id="ddlPayrollItem"
                                    [autoDisplayFirst]="false"
                                    [style]="{ 'min-width': '100%' }"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="payrollSelectItems"
                                    [filter]="true"
                                    [(ngModel)]="item.PIListID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        payrollItems
                                        | itemlookup: 'PIListID':item?.PIListID
                                    )?.PayrollItem
                                ">
                                    {{
                                    (
                                    payrollItems
                                    | itemlookup: 'PIListID':item?.PIListID
                                    )?.PayrollItem
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Holiday Auths -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <ef-checkbox [rowData]="item" property="AuthorizedHolidays"></ef-checkbox>
                                <!-- <p-checkbox
                                binary="true"
                                [(ngModel)]="item.AuthorizedHolidays"
                            ></p-checkbox> -->
                            </ng-template>
                            <ng-template pTemplate="output">
                                <i class="tickcross" [ngClass]="{
                                    fa: true,
                                    'fa-check': item.AuthorizedHolidays,
                                    green: item.AuthorizedHolidays
                                }"></i>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Split Day -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="splitdays" [rowData]="item"
                                        property="TimeCardSplitDayID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="splitdays"
                                    [filter]="true"
                                    [(ngModel)]="item.TimeCardSplitDayID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        splitdays
                                        | itemlookup
                                            : 'value'
                                            : item?.TimeCardSplitDayID
                                    )?.label
                                ">
                                    {{
                                    item?.TimeCardSplitDayID === 9
                                    ? ''
                                    : (
                                    splitdays
                                    | itemlookup
                                    : 'value'
                                    : item?.TimeCardSplitDayID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- EXPENSE GROUP -->
                    <!-- Expense Entry -->
                    <td *ngIf="expenseChecked">
                        <i class="tickcross" [ngClass]="{
                            fa: true,
                            'fa-check': item.ExpenseAllowed
                        }"></i>
                    </td>
                    <!-- Credit Card -->
                    <td *ngIf="expenseChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <!-- <div>
                                <p-multiSelect
                                    [options]="creditCards"
                                    [(ngModel)]="item.CCAccountListID"
                                    appendTo="body"
                                    maxSelectedLabels="1"
                                    selectedItemsLabel="{0} items selected"
                                ></p-multiSelect>

                            </div> -->
                                <p-multiSelect [options]="creditCards" [(ngModel)]="item.CCAccountListID"
                                    appendTo="body" maxSelectedLabels="1"
                                    selectedItemsLabel="{0} items selected"></p-multiSelect>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="item?.CCAccountListID?.length > 1 ? 'Multiple' :
                                    (
                                        creditCards
                                        | itemlookup
                                            : 'value'
                                            : item?.CCAccountListID
                                    )?.label
                                ">
                                    {{ item?.CCAccountListID?.length > 1 ? 'Multiple' :
                                    (
                                    creditCards
                                    | itemlookup
                                    : 'value'
                                    : item?.CCAccountListID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- REMINDERS GROUP -->
                    <!-- Expected Hrs Per Day -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input title="Expected Hours Per Day" pInputText [(ngModel)]="item.Expectedhrsperday" />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ item?.Expectedhrsperday }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Expected Hrs Per Week -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input title="Expected Hours Per Week" pInputText
                                    [(ngModel)]="item.Expectedhrsperweek" />
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ item?.Expectedhrsperweek }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Do Not Remind -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <ef-checkbox [rowData]="item" property="IsPartTime"></ef-checkbox>
                                <!-- <p-checkbox
                                binary="true"
                                [(ngModel)]="item.IsPartTime"
                            ></p-checkbox> -->
                            </ng-template>
                            <ng-template pTemplate="output">
                                <i class="tickcross" [ngClass]="{
                                    fa: true,
                                    'fa-check': item.IsPartTime
                                }"></i>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Time Zone -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="timeZones" [rowData]="item"
                                        property="EmpTimeZone"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="timeZones"
                                    [filter]="true"
                                    [(ngModel)]="item.EmpTimeZone"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        timeZones
                                        | itemlookup: 'value':item?.EmpTimeZone
                                    )?.label
                                ">
                                    {{
                                    (
                                    timeZones
                                    | itemlookup: 'value':item?.EmpTimeZone
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Reminder Delivery -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="messageDeliveryTypes" [rowData]="item"
                                        property="ReminderdeliveryID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="messageDeliveryTypes"
                                    [filter]="true"
                                    [(ngModel)]="item.ReminderdeliveryID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        messageDeliveryTypes
                                        | itemlookup
                                            : 'value'
                                            : item?.ReminderdeliveryID
                                    )?.label
                                ">
                                    {{
                                    (
                                    messageDeliveryTypes
                                    | itemlookup
                                    : 'value'
                                    : item?.ReminderdeliveryID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- PROCESSING GROUP -->
                    <!-- Cost Center -->
                    <td *ngIf="processingChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="costCenters" [rowData]="item"
                                        property="CostCenterID"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="costCenters"
                                    [filter]="true"
                                    [(ngModel)]="item.CostCenterID"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        costCenters
                                        | itemlookup: 'value':item?.CostCenterID
                                    )?.label
                                ">
                                    {{
                                    (
                                    costCenters
                                    | itemlookup: 'value':item?.CostCenterID
                                    )?.label
                                    }}
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Unique Pay Cycle -->
                    <td *ngIf="processingChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div>
                                    <ef-dropdown [items]="payrollFrequency" [rowData]="item"
                                        property="PayrollFrequency"></ef-dropdown>
                                    <!-- <p-dropdown
                                    [style]="{ 'min-width': '100%' }"
                                    [autoDisplayFirst]="false"
                                    [virtualScroll]="true"
                                    [itemSize]="environment.dropdownItemHeight"
                                    appendTo="body"
                                    [options]="payrollFrequency"
                                    [filter]="true"
                                    [(ngModel)]="item.PayrollFrequency"
                                ></p-dropdown> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        payrollFrequency
                                        | itemlookup
                                            : 'value'
                                            : item?.PayrollFrequency
                                    )?.label
                                ">
                                    <span *ngIf="item?.PayrollFrequency == '0'">
                                        {{''}}
                                    </span>
                                    <span *ngIf="item?.PayrollFrequency != '0'">
                                        {{
                                        (
                                        payrollFrequency
                                        | itemlookup
                                        : 'value'
                                        : item?.PayrollFrequency
                                        )?.label
                                        }}
                                    </span>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Usertype -->
                    <td *ngIf="processingChecked">
                        {{ item?.Usertype }}
                    </td>
                    <!-- Hire Date -->
                    <td *ngIf="processingChecked">
                        {{
                        moment(item?.HireDate).isValid()
                        ? moment(item?.HireDate).format('L')
                        : ''
                        }}
                    </td>
                    <!-- Release Date -->
                    <td *ngIf="processingChecked">
                        <p-cellEditor *featureFlag="'qboReleaseDate'; else alternate">
                            <ng-template pTemplate="input">
                                <div *ngIf="item.IsActive == false || qboEnabled">
                                    <p-calendar #releaseDate [(ngModel)]="item.ReleaseDate" [yearNavigator]="true"
                                        [monthNavigator]="true" appendTo="body"></p-calendar>
                                </div>
                                <div *ngIf="item.IsActive == true && !qboEnabled">
                                    {{
                                    moment(item?.ReleaseDate).isValid()
                                    ? moment(item?.ReleaseDate).format('L')
                                    : ''
                                    }}
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                moment(item?.ReleaseDate).isValid()
                                ? moment(item?.ReleaseDate).format('L')
                                : ''
                                }}
                            </ng-template>
                        </p-cellEditor>
                        <ng-template #alternate>
                            {{
                            moment(item?.ReleaseDate).isValid()
                            ? moment(item?.ReleaseDate).format('L')
                            : ''
                            }}
                        </ng-template>
                    </td>
                    <!-- Lock out -->
                    <td *ngIf="timeChecked">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="input-group input-group-after">
                                    <p-calendar #calLockDate [(ngModel)]="item.LockDate" [yearNavigator]="true"
                                        [monthNavigator]="true" appendTo="body"></p-calendar>
                                    <!-- <div class="input-group-append" style="height: 1.7em">
                                        <span class="input-group-text" style="cursor: pointer"
                                            (click)="item.LockDate = undefined">
                                            <i class="fa fa-times"></i>
                                        </span>
                                    </div> -->
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{
                                item.LockDate
                                ? moment(item.LockDate).isValid()
                                ? moment(item.LockDate).format('L')
                                : item.LockDate
                                : item.LockDate
                                }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</div>
